import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerFeeNote/messages';
import { translate } from 'containers/services/translate';
import Card from '@material-ui/core/Card';
import { Tab, Tabs, Grid } from '@material-ui/core';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import CardContent from '@material-ui/core/CardContent';
import CardTitle from 'containers/common/Card/CardTitle';
import userPrivelges from 'containers/services/security/user-privileges';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import {
  requestManagerFeeNotes,
  requestOpeningManagerFeeNotes,
  makeDecisionFeeNote,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByPolicyNumber,
  requestManagerAllFeeNotes,
  requestCreateCostsSagis,
  requestFeeNotesByRegistrationNumber,
} from 'containers/ManagerFeeNote/actions';
import { get, isNil, isEmpty } from 'lodash';
import { setNotificationFeeNote } from 'containers/AppContainer/actions';
import { makeSelectNotifFeeNoteManager } from 'containers/AppContainer/selectors';
import SearchBarFeeNote, { SearchQuery } from 'components/SearchBarFeeNote';
import {
  requestCreateFeeNote,
  requestFeeNoteCosts,
  requestUpdateFeeNoteAmount,
  requestUpdateFeeNoteStatus,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestUpdateFirmReferenceManager,
} from 'containers/LawyerFeeNote/actions';
import { isManager, isOpeningManager } from 'containers/AppContainer/utils';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import { FeeNoteContainer } from 'containers/LawyerFeeNote/styled-components';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import FeeNoteTable from 'containers/LawyerFeeNote/FeeNoteTable';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { ALL_STATUS } from 'containers/LawyerFeeNote/constants';
import { Listings } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { isTransactionManager } from 'helpers/utils';

export interface ManagerFeeNoteProps {
  location: { pathname: string };
  intl: IntlShape;
  feeNotes: FeeNote[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  documentId: string;
  setDocumentId: Function;
  requestManagerFeeNotes: Function;
  requestOpeningManagerFeeNotes: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  requestFeeNotesByClaimNumb: Function;
  listings: Listings;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  feeNotesCount: number;
  requestFeeNotesByPolicyNumber: Function;
  requestUpdateFeeNoteAmount: Function;
  requestUpdateFeeNoteStatus: Function;
  notifFeeNote: any;
  requestManagerAllFeeNotes: Function;
  setNotificationFeeNote: Function;
  loaders: {};
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestCreateCostsSagis: Function;
  requestFeeNotesByRegistrationNumber: Function;
  requestUpdateFirmReferenceManager: Function;
}

export const ManagerFeeNote: React.FC<ManagerFeeNoteProps> = (
  props,
): JSX.Element => {
  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>({
    claimNumber: null,
    policyNumber: null,
  });
  const [tab, setTab] = React.useState(0);
  const [page, setPage] = React.useState<number>(0);
  React.useEffect(() => {
    if (!isEmpty(props.notifFeeNote)) {
      setTab(ALL_STATUS.indexOf(get(props.notifFeeNote, 'status')));
      props.requestManagerAllFeeNotes(get(props.notifFeeNote, 'status'));
    }
  }, [props.notifFeeNote]);
  const handleChange = (event: React.ChangeEvent<{}>, newTabIndex: number) => {
    setTab(newTabIndex);
    setPage(0);
  };

  const handlerSearch = () => {
    const transactionInboxeAreaIds = userPrivelges
      .getUserInboxes()
      .map((el: any) =>
        !isNil(el.transactionInboxeAreaId)
          ? el.transactionInboxeAreaId
          : undefined,
      );
    const transactionAreaIds = transactionInboxeAreaIds.map((item: any) =>
      get(
        get(props.listings, 'transactionInboxeArea', []).find(
          (el: any) => el.id === item,
        ),
        'transactionAreaId',
      ),
    );
    if (searchQuery.claimNumber) {
      return isTransactionManager()
        ? props.requestFeeNotesByClaimNumb(
            searchQuery.claimNumber,
            transactionAreaIds,
          )
        : props.requestFeeNotesByClaimNumb(searchQuery.claimNumber);
    }
    if (searchQuery.policyNumber) {
      return isTransactionManager()
        ? props.requestFeeNotesByPolicyNumber(
            searchQuery.policyNumber,
            transactionAreaIds,
          )
        : props.requestFeeNotesByPolicyNumber(searchQuery.policyNumber);
    }
    if (searchQuery.registrationNumber) {
      props.requestFeeNotesByRegistrationNumber(searchQuery.registrationNumber);
    }
  };

  const handlerRefresh = () => {
    setSearchQuery({
      claimNumber: null,
      policyNumber: null,
    });
    props.setNotificationFeeNote(null);
    if (isOpeningManager()) {
      props.requestOpeningManagerFeeNotes(ALL_STATUS[tab], 0, 25);
    } else if (isTransactionManager()) {
      const transactionInboxeAreaIds = userPrivelges
        .getUserInboxes()
        .map((el: any) =>
          !isNil(el.transactionInboxeAreaId)
            ? el.transactionInboxeAreaId
            : undefined,
        );
      const transactionAreaIds = transactionInboxeAreaIds.map((item: any) =>
        get(
          get(props.listings, 'transactionInboxeArea', []).find(
            (el: any) => el.id === item,
          ),
          'transactionAreaId',
        ),
      );
      props.requestManagerFeeNotes(ALL_STATUS[tab], 0, 25, transactionAreaIds);
    } else {
      props.requestManagerFeeNotes(ALL_STATUS[tab], 0, 25);
    }
  };

  return (
    <FeeNoteContainer>
      <Card>
        <Tabs
          value={tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          className="tab-container"
        >
          <Tab
            label={translate(messages.pendingTabTitle, props)}
            data-testid="tab-1"
          />
          <Tab label={translate(messages.validatedTabTitle, props)} />
          <Tab label={translate(messages.rejectedTabTitle, props)} />
        </Tabs>
        <CardContent>
          <div className="header">
            <Grid container direction="row">
              <Grid item xs={8}>
                <CardTitle
                  count={props.feeNotesCount}
                  message={translate({ ...messages.feeNoteCardTitle }, props)}
                />
              </Grid>
              <Grid item xs={4}>
                <SearchBarFeeNote
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleSearch={handlerSearch}
                  handlerRefresh={handlerRefresh}
                />
              </Grid>
            </Grid>
          </div>
          <FeeNoteTable
            feeNotes={
              !isEmpty(props.notifFeeNote)
                ? props.feeNotes.filter(
                    (el: any) =>
                      el.id === Number(get(props.notifFeeNote, 'id')),
                  )
                : props.feeNotes
            }
            feeNotesCount={props.feeNotesCount || 0}
            requestAllFeeNotes={props.requestAllFeeNotes}
            allFeeNotes={props.allFeeNote}
            requestFeeNotes={
              isOpeningManager()
                ? props.requestOpeningManagerFeeNotes
                : props.requestManagerFeeNotes
            }
            requestCreateFeeNote={props.requestCreateFeeNote}
            requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
            keyclokToken={props.keyclokToken}
            resetUploadDocumentStore={props.resetUploadDocumentStore}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            setNotificationFeeNote={props.setNotificationFeeNote}
            documentId={props.documentId}
            isManager={isManager(props)}
            status={ALL_STATUS[tab]}
            showButtonAdd={true}
            makeDecisionFeeNote={props.makeDecisionFeeNote}
            listings={props.listings}
            viewByClaim={false}
            setPage={setPage}
            page={page}
            requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
            requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
            notifFeeNote={props.notifFeeNote}
            requestManagerAllFeeNotes={props.requestManagerAllFeeNotes}
            loaders={props.loaders}
            requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
            requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
            requestCreateCostsSagis={props.requestCreateCostsSagis}
            requestUpdateFirmReferenceManager={
              props.requestUpdateFirmReferenceManager
            }
          />
        </CardContent>
      </Card>
    </FeeNoteContainer>
  );
};

const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestOpeningManagerFeeNotes,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteCosts,
  makeDecisionFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestFeeNotesByPolicyNumber,
  requestUpdateFeeNoteAmount,
  requestUpdateFeeNoteStatus,
  requestManagerAllFeeNotes,
  setNotificationFeeNote,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestCreateCostsSagis,
  requestFeeNotesByRegistrationNumber,
  requestUpdateFirmReferenceManager,
};

const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  listings: makeSelectListings(),
  allFeeNote: makeSelectAllFeeNotes(),
  notifFeeNote: makeSelectNotifFeeNoteManager(),
  loaders: selectedLoader,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ManagerFeeNote));
